<template>
	<footer class="footer">
		<div class="container">
			<div class="footer__Top">
				<nav v-if="footerTopLinks?.length" class="footer__TopNavigation">
					<ul v-for="group in footerTopLinks" class="footer__NavGroup">
						<li>
							<span>
								<template v-if="group.url">
									<nuxt-link :to="group.url" :target="group.external ? '_blank' : ''" :external="group.external">{{
										group.title
									}}</nuxt-link>
								</template>
								<template v-else>
									<h3 v-text="group.title" />
								</template>
							</span>
						</li>
						<template v-for="link in group.items" >
							<li v-if="link.url">
								<nuxt-link :to="link.url" :target="link.external ? '_blank' : ''" :external="link.external">{{ link.title }}</nuxt-link>
							</li>
						</template>
					</ul>
				</nav>

				<div class="footer__TopRight">
					<div class="footer__Newsletter">
						<h3 v-text="$t('newsletter.title')" />

						<TextField v-model="newsletterEmail" :placeholder="$t('newsletter.placeholder')">
							<template #append>
								<button type="button" @click="submitNewsletter">
									{{ $t('newsletter.submit') }}
									<Icon name="arrow-right-long" />
								</button>
							</template>
						</TextField>
					</div>

					<div class="footer__SocialNetworks">
						<h3 v-text="$t('socialNetworks.title')" />
						<ul>
							<li v-for="link in socialNetworks">
								<nuxt-link :href="link.href" :arial-label="link.title" :external="true" target="_blank" rel="nofollow">
									{{ link.title }}
									<template v-if="link.title === 'Facebook'">
										<Icon name="facebook" />
									</template>
									<template v-if="link.title === 'Instagram'">
										<Icon name="instagram" />
									</template>
									<template v-if="link.title === 'YouTube'">
										<Icon name="youtube" />
									</template>
								</nuxt-link>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="footer__Bottom">
				<nuxt-link :to="link('Home')" class="footer__Logo">
					{{ $t('homepage') }}
					<Icon name="logo" />
				</nuxt-link>

				<div>
					<nav>
						<nuxt-link v-for="link in footerBottomLinks" :to="link.url" :external="link.external" :target="link.external ? '_blank' : ''">
							{{ link.title }}
						</nuxt-link>
						<div class="footer__Copyright">© Aminess {{ currentYear }}</div>
					</nav>
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup>
	const { link, socialNetworks } = useSetup();
	const currentYear = new Date().getFullYear();
	const newsletterEmail = ref('');
	
	const { menus } = useSetup()
	const footerTopLinks = computed(() => menus.value.footer)
	const footerBottomLinks = computed(() => menus.value.footerBottom)

	function submitNewsletter() {
		if (newsletterEmail.value.length > 0) {
			navigateTo({ path: link('Newsletter'), query: { email: newsletterEmail.value, } });
		} else navigateTo({ path: link('Newsletter') });
	}
</script>

<style lang="scss">
	@import url('@/assets/styles/components/_footer.scss');
</style>
